/**
 * Module-scope registry of client-tool dispatchers, looked up by agentId.
 *
 * Lives in @tunasong/redux because the agent-stream RTK Query handler is the
 * consumer; the producer (a React hook in plugins/agent) registers a resolver
 * at module load. This avoids @tunasong/redux taking a hard dep on
 * plugins/agent — the registry is the seam.
 *
 * One resolver per app, replaced (not appended) on each call. The resolver
 * is responsible for routing the agentId to the correct dispatcher instance
 * (typically one per active AgentChat thread).
 */

export interface ClientToolCallEnvelope {
  toolName: string
  toolCallId: string
  input: unknown
}

export type AgentDispatcherResult =
  | { ok: true; result?: unknown }
  | { ok: false; error: string; limit?: number }

export type AgentDispatcher = (call: ClientToolCallEnvelope) => Promise<AgentDispatcherResult>

type Resolver = (agentId: string) => AgentDispatcher | undefined

let resolver: Resolver | undefined

export const setAgentDispatcherResolver = (next: Resolver): void => {
  resolver = next
}

export const getAgentDispatcher = (agentId: string): AgentDispatcher | undefined =>
  resolver?.(agentId)

/** Test helper. Not for production use. */
export const clearAgentDispatcherResolver = (): void => {
  resolver = undefined
}
